import { ip_back } from "../config";

function authHeaders() {
  const token =
    (typeof window !== "undefined" && localStorage.getItem("token")) || "";
  return token
    ? { Authorization: token, "Content-Type": "application/json" }
    : { "Content-Type": "application/json" };
}

async function parseJson(resp) {
  try {
    return await resp.json();
  } catch {
    return {};
  }
}

/** Active corners (+ optional Player A/B ROIs) for a table. */
export async function getActiveTableGeometry(tableId, courtSide = "") {
  if (!tableId) return null;
  const qs = new URLSearchParams({ table_id: tableId });
  if (courtSide) qs.set("court_side", courtSide);
  const resp = await fetch(
    `${ip_back}api/mobileAPI/table-geometry?${qs.toString()}`,
    { method: "GET", headers: authHeaders() }
  );
  const json = await parseJson(resp);
  if (!resp.ok) return null;
  return json?.data || null;
}

export async function getTableGeometryById(geometryId) {
  if (!geometryId) return null;
  const resp = await fetch(
    `${ip_back}api/mobileAPI/table-geometry/${encodeURIComponent(geometryId)}`,
    { method: "GET", headers: authHeaders() }
  );
  const json = await parseJson(resp);
  if (!resp.ok) return null;
  return json?.data || null;
}

/**
 * Create new active version (deactivates previous for same table+side).
 * Pass roiLeft / roiRight to store Player A/B on the table calibration.
 */
export async function saveTableGeometry({
  tableId,
  cornersNorm,
  courtSide = "",
  clubId = null,
  roiLeft = undefined,
  roiRight = undefined,
}) {
  const body = {
    table_id: tableId,
    court_side: courtSide,
    club_id: clubId,
    corners_norm: cornersNorm,
  };
  if (roiLeft !== undefined) body.roi_left = roiLeft;
  if (roiRight !== undefined) body.roi_right = roiRight;
  const resp = await fetch(`${ip_back}api/mobileAPI/table-geometry`, {
    method: "POST",
    headers: authHeaders(),
    body: JSON.stringify(body),
  });
  const json = await parseJson(resp);
  if (!resp.ok || json?.status === false) {
    throw new Error(json?.message || "Failed to save table geometry");
  }
  return json.data;
}
